import Breadcrumb from "../../../components/breadcrumbs/Breadcrumb.vue";
import { SnackBarModule } from "../../../modules/SnackBarModule";
import { ProcessamentoService } from "../../../services/ProcessamentoService";
export default {
    name: "ImportarElementosPrimarios",
    components: {
        Breadcrumb
    },
    data: () => ({
        breadcrumbs: [
            {
                text: 'Página Inicial',
                disabled: false,
                href: '/',
            },
            {
                text: 'Elementos Primários',
                disabled: false
            },
            {
                text: 'Importar Elementos Primários',
                disabled: true
            }
        ],
        arquivo: null,
        loading: false,
        uploadProgress: null,
        blockInputFile: false,
        scheduledList: [],
        tipoSelecionado: 'unidade-primaria-ppag',
        tiposElementos: [
            { label: 'EP. PPAG', value: 'unidade-primaria-ppag' },
            { label: 'EP. Emenda Estadual', value: 'ep-emenda-estadual' },
            { label: 'EP. Emenda Federal', value: 'ep-emenda-federal' },
            { label: 'EP. Convênios Federais', value: 'ep-convenios-federais' },
            { label: 'EP. GENÉRICOS', value: 'ep-genericos' }
        ]
    }),
    created() {
        this.loadScheduledList();
    },
    computed: {
        disabledInputFile() {
            return this.blockInputFile || !this.tipoSelecionado;
        }
    },
    methods: {
        async loadScheduledList() {
            const scheduledList = await ProcessamentoService.scheduled('unidades-primarias');
            this.scheduledList = scheduledList.data;
        },
        async refreshPage() {
            this.loadScheduledList();
            await SnackBarModule('Lista de Processos Atualizada', 'info');
        },
        async retryProcessamento(item) {
            try {
                const formData = new FormData();
                formData.append('id', item.id);

                const response = await ProcessamentoService.retry(formData);
                if (response) {
                    this.loadScheduledList();
                } 
            } catch (error) {
                console.error('Erro ao tentar reprocessar o item:', error);
            }
        },
        uploadFile() {
   
            if (!this.arquivo) {
                console.error('Nenhum arquivo selecionado.');
                return;
            }

            if (!this.tipoSelecionado) {
                SnackBarModule('Por favor, selecione o tipo de elemento primário antes de fazer o upload.', 'warning');
                return;
            }
            
            this.blockInputFile = true;
            this.uploadProgress = 0;
            
            const formData = new FormData();
            formData.append('arquivo', this.arquivo);
            formData.append('type', this.tipoSelecionado);

            ProcessamentoService.store(formData)
                .then(response => {
                    console.log('=== RESPOSTA DA API ===');
                    console.log('Response completa:', response);
                    console.log('Response type:', typeof response);
                    console.log('Response.error:', response ? response.error : 'response é null/undefined');
                    console.log('Response.message:', response ? response.message : 'response é null/undefined');

                    // Verificar se houve erro ou se a resposta é false
                    if (!response || response === false || (response && response.error === true)) {
                        this.blockInputFile = false;
                        this.uploadProgress = null;
                        this.arquivo = null;
                        
                        // Mensagem de erro padrão para documento incompatível
                        const errorMsg = 'Ocorreu um erro devido ao documento ser incompatível com a entidade';
                        SnackBarModule(errorMsg, 'error');
                        return;
                    }

                    let progress = 0;
                    const interval = setInterval(() => {
                        progress += Math.random() * 10;
                        if (progress >= 100) {
                            clearInterval(interval);
                            this.uploadProgress = null;
                            this.blockInputFile = false;
                            this.arquivo = null;
                            this.loadScheduledList();
                            SnackBarModule('Arquivo enviado com sucesso!', 'success');
                        } else {
                            this.uploadProgress = progress;
                        }
                    }, 500);
                })
                .catch(() => {
                    this.uploadProgress = null;
                    this.blockInputFile = false;
                    this.arquivo = null;
                    SnackBarModule('Ocorreu um erro devido ao documento ser incompatível com a entidade', 'error');
                });
        },
        getStatusClass(item) {
            if (!item.processado) {
                return 'awaiting-process';
            } else if (item.erro) {
                return 'processing-error';
            } else {
                return 'processing-success';
            }
        },
        getStatusText(item) {
            if (!item.processado) {
                return 'Processamento em andamento...';
            } else if (item.erro) {
                return 'Erro no processamento. Clique para reprocessar.';
            } else {
                return 'Processamento concluído';
            }
        },
        getStatusIcon(item) {
            if (!item.processado) {
                return 'mdi-clock-outline';
            } else if (item.erro) {
                return 'mdi-alert-circle-outline';
            } else {
                return 'mdi-checkbox-marked-circle-outline';
            }
        },
        getIconColor(item) {
            if (!item.processado) {
                return 'warning';
            } else if (item.erro) {
                return 'error';
            } else {
                return 'success';
            }
        },
        getTitleColor(item) {
            if (item.erro) {
                return 'error--text';
            } else if (item.processado) {
                return 'success--text';
            } else {
                return 'warning--text';
            }
        },
        getSubtitleColor(item) {
            if (item.erro) {
                return 'error--text';
            } else if (item.processado) {
                return 'success--text';
            } else {
                return 'warning--text';
            }
        },
        getDividerClass(item) {
            if (item.erro) {
                return 'divider-error';
            } else if (item.processado) {
                return 'divider-success';
            } else {
                return 'divider-warning';
            }
        },
        handleFileSelect(event) {
            const file = event.target.files[0];
            console.log('=== ARQUIVO SELECIONADO ===');
            console.log('File object:', file);
            console.log('File name:', file ? file.name : 'null');
            console.log('File size:', file ? file.size : 'null');
            console.log('File type:', file ? file.type : 'null');
            
            if (file) {
                this.arquivo = file;
                console.log('Arquivo armazenado em this.arquivo:', this.arquivo);
                this.uploadFile();
            }
        },
        handleFileDrop(event) {
            if (this.blockInputFile) return;
            
            const files = event.dataTransfer.files;
            if (files.length > 0) {
                const file = files[0];
                if (file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || 
                    file.type === 'application/vnd.ms-excel' ||
                    file.name.endsWith('.xlsx') || 
                    file.name.endsWith('.xls')) {
                    this.arquivo = file;
                    this.uploadFile();
                } else {
                    this.$toast.error('Formato de arquivo não suportado. Use apenas .xlsx ou .xls');
                }
            }
        },
        removeFile() {
            this.arquivo = null;
        },
        getErrorSummary(erro) {
            if (!erro) return '';
            
            const totalMatch = erro.match(/Total de registros com erro: (\d+)/);
            if (totalMatch) {
                return `${totalMatch[1]} registro(s) com erro - Clique para ver detalhes`;
            }
            
            return 'Erro no processamento - Clique para ver detalhes';
        },
        parseErrors(erro) {
            if (!erro) return [];
            
            const erros = [];
            const linhas = erro.split('\n');
            let erroAtual = null;
            
            for (let i = 0; i < linhas.length; i++) {
                const linha = linhas[i].trim();
                
                if (!linha || linha.startsWith('Total de registros')) {
                    continue;
                }
                
                const erroMatch = linha.match(/--- Erro #(\d+) \(Linha (\d+)\) ---/);
                if (erroMatch) {
                    if (erroAtual) {
                        erros.push(erroAtual);
                    }
                    
                    erroAtual = {
                        numero: parseInt(erroMatch[1]),
                        linha: parseInt(erroMatch[2]),
                        motivo: '',
                        dados: {}
                    };
                    continue;
                }
                
                if (linha.startsWith('Motivo:')) {
                    if (erroAtual) {
                        erroAtual.motivo = linha.replace('Motivo:', '').trim();
                    }
                    continue;
                }
                
                if (linha.startsWith('Dados:')) {
                    if (erroAtual) {
                        const dadosStr = linha.replace('Dados:', '').trim();
                        const dadosPairs = dadosStr.split(',').map(pair => pair.trim());
                        dadosPairs.forEach(pair => {
                            const equalIndex = pair.indexOf('=');
                            if (equalIndex > 0) {
                                const key = pair.substring(0, equalIndex).trim();
                                const value = pair.substring(equalIndex + 1).trim();
                                if (key && value) {
                                    erroAtual.dados[key] = value;
                                }
                            }
                        });
                    }
                    continue;
                }
            }
            
            if (erroAtual) {
                erros.push(erroAtual);
            }
            
            if (erros.length === 0 && erro.trim()) {
                return [{
                    numero: 1,
                    linha: 0,
                    motivo: erro.length > 200 ? erro.substring(0, 200) + '...' : erro,
                    dados: {}
                }];
            }
            
            return erros;
        },
        formatFieldName(key) {
            const fieldNames = {
                'Ano': 'Ano',
                'Ação': 'Ação',
                'Grupo': 'Grupo',
                'Elit': 'Elemento Item',
                'Diretoria': 'Diretoria',
                'Gerência': 'Gerência',
                'Descrição': 'Descrição',
                'Fonte': 'Fonte',
                'Frequencia': 'Frequência',
                'Valor_total_previsto': 'Valor Total Previsto'
            };
            return fieldNames[key] || key;
        }
    }
};